import React from "react";

import PotentialProjectList from "./list.js";

import { useDocumentTitle } from "$utils/document-title.js";
import { getTerm } from "$stores/dictionary";

const PotentialProjects = () => {
    useDocumentTitle(`Potential ${getTerm("project")} List`);

    return (
        <div>
            <PotentialProjectList />
        </div>
    );
};

export default PotentialProjects;
